import { createFileRoute } from '@tanstack/react-router'

import { SpaceDashboardPage } from '@/pages/space-dashboard/SpaceDashboard.page'

export const Route = createFileRoute('/_auth/dashboard')({
  beforeLoad: () => {
    // TODO: we should check if the user has access to the projects
  },
  component: SpaceDashboardPage,
})
